<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Event Jobs</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>Job</th>
                        <th>Timeslot</th>
                        <th>Members</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(eventJob, index) in eventJobs">
                        <tr v-for="(timeslot, timeslotIndex) in eventJob.club_event_job_timeslots">
                            <td
                                v-if="timeslotIndex === 0"
                                :rowspan="eventJob.club_event_job_timeslots.length"
                            >
                                {{ eventJob.job_name }}
                                <span v-if="eventJob.email_reminders == 1"><i class="glyphicon glyphicon-envelope text-primary"></i></span>
                            </td>
                            <td>{{ timeslot.timeslot_name }}</td>
                            <td>
                                <span v-for="signup in timeslot.club_event_job_signups">
                                    {{ signup.member.full_name }}
                                    <button v-if="!signup.attended" @click="markAttended(timeslot.id, signup.member_id)" class="btn btn-sm btn-success"><i class="glyphicon glyphicon-ok"></i></button>
                                    <button @click="removeMember(timeslot.id, signup.member.id)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button>
                                </span>
                                <button @click="addMemberForm(timeslot.id)" class="btn btn-success pull-right"><i class="glyphicon glyphicon-plus"></i></button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <vuedal @members-changed="getEventJobs()"></vuedal>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {default as Vuedals, Component as Vuedal, Bus as VuedalsBus} from 'vuedals';

    Vue.use(Vuedals);

    export default {
        components: {
            Vuedal
        },

        props: [
            'eventId'
        ],

        data: function () {
            return {
                eventJobs: []
            };
        },

        mounted() {
            this.getEventJobs();
        },

        methods: {
            getEventJobs() {
                axios.get(`/api/v1/club_events/${this.eventId}/volunteers`).then((response) => {
                    this.eventJobs = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading event volunteers.', type: 'error'});
                });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY");
            },

            removeMember(timeslotId, id) {
                axios.delete(`/api/v1/timeslots/${timeslotId}/members/${id}`)
                    .then(response => {
                        this.getEventJobs();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the member.', type: 'error'});
                    });
            },

            markAttended(timeslotId, id) {
                axios.post(`/api/v1/timeslots/${timeslotId}/members/${id}/attended`)
                    .then(response => {
                        this.getEventJobs();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem while changing user status.', type: 'error'});
                    });
            },

            editJob(event) {
                this.$emit('job-edit', event);
            },

            addMemberForm(timeslotId) {
                this.$vuedals.$emit('new', {
                    name: 'add-member',
                    title: 'Add Member',
                    props: {
                        timeslotId: timeslotId
                    },
                    component: 'v-member-form'
                });
            }
        },
    }
</script>
